import { render, staticRenderFns } from "./ThreatView.vue?vue&type=template&id=1bbfb7da&"
import script from "./ThreatView.vue?vue&type=script&lang=js&"
export * from "./ThreatView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports